import { InfoCard } from '../../base/info-card/info-card';
import { LeftImage } from './left-image';

export interface AuthFormContainerProps {
  children: React.ReactNode;
  errorMessage?: string;
  onDismissError?: () => void;
}

export const AuthFormContainer = ({
  children,
  errorMessage,
  onDismissError
}: AuthFormContainerProps) => {
  return (
    <div className="flex min-h-screen w-full bg-white">
      {errorMessage && (
        <div className="fixed top-4 right-4 z-50 w-full max-w-md">
          <InfoCard dismissable severity="error" onDismiss={onDismissError}>
            {errorMessage}
          </InfoCard>
        </div>
      )}
      <div className="flex w-full bg-white relative">
        <div className="hidden bg-white lg:flex lg:justify-center lg:w-[60%] h-full overflow-hidden">
          <LeftImage />
        </div>
        <div className="flex w-full flex-col justify-center p-8 lg:w-[40%]">
          {children}
        </div>
      </div>
    </div>
  );
};
